<template>
  <div class="pg-dialog-select-border">
    <div class="pg-dialog-select-border__tags">
      <template v-if="multiple">
        <Tag
          class="pg-dialog-select-border__tag"
          :style="{ maxWidth: otherSelection.length > 0 ? 'calc(100% - 37px)' : '100%' }"
          size="small"
          type="info"
          disableTransitions
          closable
          v-for="item in frontSelections"
          :key="item.id"
          @close="remove(item)"
        >
          <span>{{ getValueByPath(item, showKey) }}</span>
        </Tag>
        <Popover
          v-if="otherSelection.length > 0"
          popper-class="pg-dialog-select-border__popper"
          class="pg-dialog-select-border__tag-other"
          placement="bottom-start"
          trigger="hover"
        >
          <template #reference>
            <Tag
              class="pg-dialog-select-border__tag pg-dialog-select-border__tag-num"
              style="width: 32px"
              size="small"
              type="info"
              >+{{ otherSelection.length }}</Tag
            >
          </template>
          <div class="pg-dialog-select-border__tag-other-content">
            <Tag
              class="pg-dialog-select-border__tag"
              size="small"
              type="info"
              disableTransitions
              closable
              v-for="item in otherSelection"
              :key="item.id"
              @close="remove(item)"
            >
              <span>{{ getValueByPath(item, showKey) }}</span>
            </Tag>
          </div>
        </Popover>
      </template>
      <template v-else>
        <Tag size="small" type="info" closable>{{ getValueByPath(showSelections, showKey) }}</Tag>
      </template>
      <span class="pg-dialog-select-border__space" v-if="!disabled" @click.self="showEvent"></span>
    </div>
    <span class="pg-dialog-select-border__placeholder" v-if="!value?.length">{{
      placeholder
    }}</span>
    <span class="pg-dialog-select-border__icon">
      <i
        class="ivu-icon-icon-pg-serach pg-dialog-select-border__icon-serach"
        v-if="!disabled"
        @click="showEvent"
      ></i>
    </span>
    <PgSelentMain
      v-if="showRander"
      v-bind="$attrs"
      :width="width"
      :multiple="multiple"
      :columnTableCode="columnTableCode"
      :column="column"
      :valueIsObj="valueIsObj"
      :selection="value"
      :selectionKey="selectionKey"
      :showKey="showKey"
      :keywordKey="keywordKey"
      :url="url"
      :method="method"
      :paramater="paramater"
      :visible="visible"
      :checkboxConfig="checkboxConfig"
      :pageSize="pageSize"
      :pageSizes="pageSizes"
      :disabledSubmitFn="disabledSubmitFn"
      @on-cancel="onCancel"
      @on-ok="onOk"
    ></PgSelentMain>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import PgSelentMain from './main.vue'
import { Tag, Popover } from 'element-ui'
import { ref, watch } from 'vue'
import {
  beforValueOldActionProps,
  useBeforValueOldActions,
  useComponentDefault,
} from '../../../hooks/index'
import { useDisplay } from '../hook/use-display'
import { http, getValueByPath } from '../../../utils/index'

const props = defineProps({
  value: [String, Array, Object],
  keywordKey: {
    type: String,
    default: 'parameters.keyword',
  },
  checkboxConfig: Object,
  multiple: Boolean,
  //选中项是否是对象
  valueIsObj: Boolean,
  //选中项的唯一值，当valueIsObj为true时直接返回查询接口返回的结构，否则返回查询接口返回的selectionKey对应的值
  selectionKey: {
    type: String,
    default: 'id',
  },
  url: String,
  method: {
    type: String,
    default: 'post',
  },
  paramater: Object,
  showKey: {
    type: String,
    default: 'name',
  },
  placeholder: {
    type: String,
    default: '请选择',
  },
  pageSize: Number,
  otherSelectionLenght: {
    type: Number,
    default: 1,
  },
  disabled: Boolean,
  defaultValuePolicy: String,
  columnTableCode: String,
  column: {
    type: [Object, Array],
    default: null,
  },
  //分页参数-可切换每页显示多少条的选项
  pageSizes: Array,
  width: {
    type: String,
    default: '740px',
  },
  // 不勾选可点击【确认】，处理函数。返回 false 则不勾选也可点击【确认】，返回 true 则需要再判断是否有勾选，有勾选才可点击
  disabledSubmitFn: { type: Function },
  ...beforValueOldActionProps,
})

const emit = defineEmits(['input'])
const { beforeEmit } = useBeforValueOldActions({
  store: props.store,
  beforValueAction: props.beforValueAction,
  emit,
})

const { visible, showRander, showEvent, onCancel, showSelections } = useDisplay(
  props,
  !props.pageSize
)
const frontSelections = ref([])
const otherSelection = ref([])
watch(
  showSelections,
  () => {
    if (props.multiple) {
      frontSelections.value = showSelections.value
        ? showSelections.value.slice(0, props.otherSelectionLenght)
        : []
      otherSelection.value = showSelections.value
        ? showSelections.value.slice(props.otherSelectionLenght)
        : []
    }
  },
  {
    immediate: true,
  }
)

const remove = (item) => {
  if (props.multiple) {
    const tempValue = [...props.value]
    const index = tempValue.findIndex(
      (im) => item[props.selectionKey] === (props.valueIsObj ? im[props.selectionKey] : im)
    )
    tempValue.splice(index, 1)
    beforeEmit(tempValue?.length > 0 ? tempValue : null)
  } else {
    beforeEmit(null)
  }
}

useComponentDefault({
  value: props.value,
  disabled: props.disabled,
  getData: () =>
    http[props.method](
      props.url,
      Object.assign(
        { pageNo: props.pageSize > 0 ? 1 : undefined, pageSize: props.pageSize ?? undefined },
        props.paramater
      ),
      { errorTip: null }
    ),
  type: props.defaultValuePolicy,
  setVal: (val) =>
    beforeEmit(props.valueIsObj ? val : val && getValueByPath(val, props.selectionKey)),
})

const onOk = (selection) => {
  beforeEmit(selection)
}
</script>
<style lang="scss">
@import '../slyle/dialog-select-border.scss';
</style>
